import React from "react";

function UploadIcon(props) {
  return (
    <svg viewBox="0 0 96 96" {...props}>
      <path
        d="M39.3 61.1h17.5V43.6h11.7L48 23.2 27.6 43.6h11.7v17.5zM27.6 67h40.8v5.8H27.6V67z"
        fill="#23293c"
      />
    </svg>
  );
}

export default UploadIcon;
